// extracted by mini-css-extract-plugin
export default {"fp_wrapper":"FailedPayment_fp_wrapper__zmoaJ","fp_cont":"FailedPayment_fp_cont__UffA6"};